import { ISelectData } from 'components/atoms/SelectComponent';

import { ETypNazvu, ETypNazvuTrans } from 'enums/lei/typNazvu';

export const leiTypNazvuSelect: ISelectData[] = [
    {
        labelcz: 'ALTERNATIVE_LANGUAGE_LEGAL_NAME',
        value: ETypNazvu.ALTERNATIVE_LANGUAGE_LEGAL_NAME
    },
    {
        labelcz: 'PREVIOUS_LEGAL_NAME',
        value: ETypNazvu.PREVIOUS_LEGAL_NAME
    },
    {
        labelcz: 'TRADING_OR_OPERATING_NAME',
        value: ETypNazvu.TRADING_OR_OPERATING_NAME
    }
];
export const leiTypNazvuTransSelect: ISelectData[] = [
    {
        labelcz: 'PREFERRED_ASCII_TRANSLITERATED_LEGAL_NAME',
        value: ETypNazvuTrans.PREFERRED_ASCII_TRANSLITERATED_LEGAL_NAME
    },
    {
        labelcz: 'AUTO_ASCII_TRANSLITERATED_LEGAL_NAME',
        value: ETypNazvuTrans.AUTO_ASCII_TRANSLITERATED_LEGAL_NAME
    }
];
